(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-steel-tongue-drum",
      exitUrl: "/pages/8-reasons-why-steel-tongue-drum",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "Discover How This Drum Calms Children Down",
      trustLine: "3,500+ happy families on 90-day guarantee",
      fixedKit: {
        name: "Your Summer Splash Setup Is Unlocked",
        tagline:
          "Best for supervised outdoor splash play on flat grass or a soft outdoor mat.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "You save \xA320 today",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Steel tongue drum in selected size included",
          "2 mallets included",
          "Carry/drawstring bag and guide included",
          "90-day money-back guarantee",
          "Simple guide to get started",
        ],
        reviews: [
          {
            text: "My grandkids absolutely love these! No more balloon mess on the lawn.",
            author: "Sandra M.",
            status: "verified buyer \u2714",
          },
          {
            text: "Best purchase this summer. My kids fight over who gets to refill them!",
            author: "Jennifer R.",
            status: "verified buyer \u2714",
          },
          {
            text: "Used these at my grandson's birthday, 15 kids going wild for 3 hours. Zero cleanup!",
            author: "Robert K.",
            status: "verified buyer \u2714",
          },
        ],
      },
      loadingItems: [
          "Steel tongue drum in selected size included",
          "2 mallets included",
          "Carry/drawstring bag and guide included",
          "90-day money-back guarantee",
          "Simple guide to get started",
      ],
      steps: [
        {
          id: "who",
          eyebrow: "Question 1 of 5",
          question: "When does your child need the most help calming down?",
          subtext: "",
          options: [
                {
            value: "After school",
            icon: "\uD83C\uDF92", 
            label: "After school",
            desc: "After school",
            },
            {
            value: "Before bed",
            icon: "\uD83D\uDECF\uFE0F", 
            label: "Before bed",
            desc: "Before bed",
            },
            {
            value: "During big emotions",
            icon: "\uD83D\uDE22", 
            label: "During big emotions",
            desc: "During big emotions",
            },
            {
            value: "When screens are taken away",
            icon: "\uD83D\uDCF5", 
            label: "When screens are taken away",
            desc: "When screens are taken away",
            },
            {
            value: "During quiet time at home",
            icon: "\uD83E\uDDD8", 
            label: "During quiet time at home",
            desc: "During quiet time at home",
            },
            {
            value: "It depends on the day",
            icon: "\uD83D\uDD04", 
            label: "It depends on the day",
            desc: "It depends on the day",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Question 2 of 5",
          question: "What do you usually reach for when they need to settle?",
          subtext: "",
          options: [
            {
            value: "Tablet or TV",
            icon: "\uD83D\uDCF1", 
            label: "Tablet or TV",
            desc: "Tablet or TV",
            },
            {
            value: "Toys",
            icon: "\uD83E\uDDF8",
            label: "Toys",
            desc: "Toys",
            },
            {
            value: "Snacks",
            icon: "\uD83C\uDF6A", 
            label: "Snacks",
            desc: "Snacks",
            },
            {
            value: "Cuddles",
            icon: "\uD83E\uDD17", 
            label: "Cuddles",
            desc: "Cuddles",
            },
            {
            value: "Quiet activities",
            icon: "\uD83E\uDDE9", 
            label: "Quiet activities",
            desc: "Quiet activities",
            },
            {
            value: "Still looking for something that works",
            icon: "\uD83D\uDD0D", 
            label: "Still looking for something that works",
            desc: "Still looking for something that works",
            },
          ],
        },
       {
        id: "surface",
        eyebrow: "Question 3 of 5",
        question: "Why sound can help create a calmer moment",
        subtext: "Gentle, repeatable sounds give kids something simple to focus on. <b>The Steel Tongue Drum</b> is easy to tap, pleasant to hear, and low-pressure from the first note, so it can become a <b>calming reset</b> without <b>lessons, screens, or complicated setup.</b>",
        infoOnly: true,
        options: [],
        },
        {
          id: "hose",
          eyebrow: "Question 4 of 5",
          question: "What kind of calm moment would help most?",
          subtext:"",
          options: [
           {
            value: "Wind-down after school",
            icon: "\uD83C\uDFE1", 
            label: "Wind-down after school",
            desc: "Wind-down after school",
            },
            {
            value: "Bedtime routine",
            icon: "\uD83C\uDF19", 
            label: "Bedtime routine",
            desc: "Bedtime routine",
            },
            {
            value: "Screen-free reset",
            icon: "\uD83C\uDFD6\uFE0F", 
            label: "Screen-free reset",
            desc: "Screen-free reset",
            },
            {
            value: "Quiet play while parents work",
            icon: "\uD83E\uDDF8", 
            label: "Quiet play while parents work",
            desc: "Quiet play while parents work",
            },
            {
            value: "A peaceful gift",
            icon: "\uD83C\uDF81", 
            label: "A peaceful gift",
            desc: "A peaceful gift",
            },
            {
            value: "Travel or on-the-go calm",
            icon: "\u2708\uFE0F", 
            label: "Travel or on-the-go calm",
            desc: "Travel or on-the-go calm",
            },
          ],
        },
        {
          id: "priority",
          eyebrow: "Question 5 of 5",
          question: "What matters most to you?",
          subtext: "",
          options: [
            {
            value: "Not too loud",
            icon: "\uD83D\uDD07", 
            label: "Not too loud",
            desc: "Not too loud",
            },
            {
            value: "Easy to start",
            icon: "\u25B6\uFE0F", 
            label: "Easy to start",
            desc: "Easy to start",
            },
            {
            value: "Keeps them off screens",
            icon: "\uD83D\uDCF5", 
            label: "Keeps them off screens",
            desc: "Keeps them off screens",
            },
            {
            value: "Sounds pleasant in the house",
            icon: "\uD83C\uDFB5", 
            label: "Sounds pleasant in the house",
            desc: "Sounds pleasant in the house",
            },
            {
            value: "Portable and easy to store",
            icon: "\uD83C\uDF92", 
            label: "Portable and easy to store",
            desc: "Portable and easy to store",
            },
            {
            value: "Feels like a thoughtful gift",
            icon: "\uD83C\uDF81", 
            label: "Feels like a thoughtful gift",
            desc: "Feels like a thoughtful gift",
            },
          ],
        },
        {
          id: "alternative",
          eyebrow: "Question 6 of 6",
          question: "What would make this a win?",
          subtext: "",
          options: [
            {
            value: "They calm down faster",
            icon: "\uD83D\uDE0C", 
            label: "They calm down faster",
            desc: "They calm down faster",
            },
            {
            value: "They have a screen-free reset",
            icon: "\uD83D\uDCF5", 
            label: "They have a screen-free reset",
            desc: "They have a screen-free reset",
            },
            {
            value: "They keep coming back to it",
            icon: "\uD83D\uDD01", 
            label: "They keep coming back to it",
            desc: "They keep coming back to it",
            },
            {
            value: "It sounds nice at home",
            icon: "\uD83C\uDFB5", 
            label: "It sounds nice at home",
            desc: "It sounds nice at home",
            },
            {
            value: "They feel proud making music",
            icon: "\uD83C\uDFB6", 
            label: "They feel proud making music",
            desc: "They feel proud making music",
            },
            {
            value: "It becomes their first instrument",
            icon: "\uD83C\uDFB9", 
            label: "It becomes their first instrument",
            desc: "It becomes their first instrument",
            },
          ],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Takes just 1 minute</div><h1 class="quiz-intro-headline">Help Your Child Calm Down With Music</h1><p class="quiz-intro-sub">Answer 5 quick questions to see how the <strong>KiddoSpace Steel Tongue Drum can give your child a simple, screen-free way to settle down and start enjoying music.</strong></p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> No more picking up balloon pieces</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Refills in 5 seconds by themselves</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> 3,500+ five-star reviews from families</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Start the quiz<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your set is being assembled</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = step.infoOnly ? true : !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Back</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p>' +
        (step.infoOnly
          ? ''
          : '<div class="quiz-options">' +
            step.options
              .map(function (o) {
                return optionCard(o, step.id);
              })
              .join("") +
            '</div>') +
        '<div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "See my recommendation" : (step.infoOnly ? "Continue" : "Next")) +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your recommended set is being assembled</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Unlocking their personal music kit \u2026</h2><p class="loading-sub" id="loading-sub">Personalized based on your answers</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub"></p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% OFF</span><span class="kit-ready-btn-text">Calm Your Child Down With The Steel Tongue Drum!</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Retake quiz</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200, 5600];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var kit = CONFIG.fixedKit,
          url = CONFIG.productUrl;
        kit.variantId &&
          kit.variantId.indexOf("REPLACE_") !== 0 &&
          (url += "?variant=" + kit.variantId);
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn && ctaBtn.setAttribute("href", url);
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your set is ready!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
 function advance() {
    var step = CONFIG.steps[state.currentStep];
    (step.infoOnly || state.answers[step.id]) &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 minute</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
